import React from 'react';
import  errorIcon from "styleguide/icons/ds2/errorcirclesolid.svg";

interface UploadErrorBannerProps {
  header: string;
  message: string;
  className?: string;
}

const UploadErrorBanner: React.FC<UploadErrorBannerProps> = ({ header, message, className = "" }) => {
  return (
    <div
      className={`ds-banner ds-banner__bg--white ds-banner--icon !p-[24px] !mb-[24px] !mt-[24px] !border-red-600 ${className}`}
      data-ds-variant="basic"
      data-ds-version="1"
      data-ds-theme="vessel"
      role="alert"
      aria-live="assertive"
    >
      <div className="ds-banner__icon-img">
        <img
          src={errorIcon}
          alt="Error icon"
          style={{ width: '42px', height: '42px' }}
        />
      </div>
      <div className="ds-banner__container">
        <div className="ds-banner__main flex flex-col">
          <div
            className="ds-banner__main-header--awareness"
            style={{ fontWeight: 350, fontSize: '20px', marginBottom: '6px' }}
          >
            {header}
          </div>
          <div className="ds-banner__main-body" style={{ fontSize: '16px' }}>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadErrorBanner;
